enum AsaPrivilege {
    CREATE_SHIPMENT = 'CreateShipment',
    SHIPMENT_OVERVIEW = 'ShipmentOverview',
    CREATE_TRANSPORTATION_LIST = 'CreateTransportationList',
    TRANSPORTATION_OVERVIEW = 'TransportationOverview',
    TRANSPORTATION_STATUS_UPDATE = 'TransportationStatusUpdate',
    TRANSPORTATION_PARCELS_PREVIEW = 'TransportationParcelsPreview',
    PARCEL_TRACKING_PARTNER = 'ParcelTrackingPartner',
    PARCEL_TRACKING_CUSTOMER = 'ParcelTrackingCustomer',
    TRACKING_INPUT = 'TrackingInput',
    PARCEL_DATA = 'ParcelData',
    REPRINT_LABEL = 'ReprintLabel',
    LOADING_LIST_ASSIGNMENT = 'LoadingListAssignment',
    AUTO_PARCELS_ASSIGNMENT = 'AutoParcelsAssignment',
    FORWARD_PARCEL = 'ForwardParcel',
    REVERT_PARCEL = 'RevertParcel',
    INITIAL_PARCEL = 'InitialParcel'
}

export { AsaPrivilege };
